import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  PostAddMoneyToWallect,
  getWalletAction,
} from "../../../../redux/action/wallet";
import BankSelection from "../children/BankSelection";
import BankDetailsSkeleton from "../../../loader/BankDetailsSkeleton";
function AddMoneyToWallet() {
  const [checkValue, setCheckValue] = useState(0);
  const { wallet, loading } = useSelector((state) => state.wallet);
  const [verifiedAccount, setVerifiedAccount] = useState([]);
  const [storeBankDetail, setStoreBankDetail] = useState(null);
  const [veiwBalace, setVeiwBalace] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleSelectbank = () => {
    dispatch(PostAddMoneyToWallect(storeBankDetail, navigate));
  };

  useEffect(() => {
    dispatch(getWalletAction());
  }, [dispatch]);

  useEffect(() => {
    const verifiedBank = wallet?.bankAccounts?.filter((items) => {
      return items?.verified;
    });
    setVerifiedAccount(verifiedBank);
  }, [wallet]);

  return (
    <div className="">
      <span className="valign-wrapper gap-1">
        <img
          src={`${process.env.PUBLIC_URL}/icons/arrow_back.svg`}
          alt="Icon"
          className="pointer"
          onClick={() => navigate("/wallet")}
        />
        <h4>Withdraw money from wallet</h4>
      </span>

      <div className="flex justify-center mt-4">
        <div style={{ minWidth: "40%" }}>
          <div className="cover white z-depth-2">
            <p className=" font-20px" style={{ padding: "1.5rem" }}>
              Transfer from wallet
            </p>
            <hr />
            <div
              className="valign-wrapper space-between"
              style={{ padding: "1.5rem" }}
            >
              <span className="valign-wrapper gap-1">
                <img
                  className="circle border purple lighten-4"
                  style={{ padding: "9px" }}
                  src={`${process.env.PUBLIC_URL}/icons/wallet-2.svg`}
                  alt="Icon"
                />

                <span>
                  <b className="font-18px">Your wallet</b>
                  <p
                    className={`cercle-purple-text font-16px ${veiwBalace ? "" : "text-decoration-underLine"
                      } pointer`}
                    style={{ marginTop: "-5px" }}
                    onClick={() => setVeiwBalace((pre) => !pre)}
                  >
                    {veiwBalace ? wallet?.availableBalance : "View balance"}
                  </p>
                </span>
              </span>
              <span className="material-icons-outlined mr-1 cercle-purple-text">
                check_circle
              </span>
            </div>
          </div>
          <div
            className="cover white z-depth-2 mt-2 "
            style={{ paddingBottom: "40px" }}
          >
            <p
              className=" font-20px textAlign-center"
              style={{ padding: "1rem 1.5rem" }}
            >
              Choose the bank account for the transfer.
            </p>
            <hr />
            {loading ? <BankDetailsSkeleton /> :
              verifiedAccount?.map((items, index) => (
                <span
                  key={items.id}
                  onClick={() => setCheckValue(index + 1)}
                  className="pointer"
                >
                  <BankSelection
                    bankDeatils={items}
                    checkValue={checkValue === index + 1}
                    setStoreBankDetail={setStoreBankDetail}
                  />
                  <hr className="ml-5 mr-2" />
                </span>
              ))}

            {verifiedAccount?.length === 0 && (
              <p className="valign-wrapper justify-center mt-2 font-20px">
                Please wait for account verification.
              </p>
            )}
          </div>
          <div className="flex justify-center mt-3">
            <button
              className={`button-style bold  ${checkValue === 0
                ? "grey lighten-2  grey-text text-darken-1"
                : "cercle-purple white-text"
                } pointer`}
              style={{ padding: "12px 55px" }}
              onClick={handleSelectbank}
              disabled={checkValue === 0}
            >
              Next
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddMoneyToWallet;
